import { getAuth } from 'firebase/auth';

const getIdToken = async () => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
        throw new Error('User not authenticated');
    }

    return await user.getIdToken();
};

export default getIdToken;